<h2 mat-dialog-title>{{ "upgradeScopesDialog.title" | translate }}</h2>
<div mat-dialog-content>
  <div [innerHTML]="'upgradeScopesDialog.description' | translate"></div>
</div>
<div mat-dialog-actions>
  <a
    class="learn-more"
    href="{{ 'link.helpUpgradeScopes' | withFlavor | translate }}"
    mat-button
    color="primary"
    target="_blank"
  >
    <mat-icon fontSet="material-symbols-rounded">help</mat-icon>
    {{ "shared.learnMore" | translate }}
  </a>
  <button mat-button (click)="cancel()">{{ "shared.cancel" | translate }}</button>
  <button mat-flat-button color="primary" (click)="confirm()">
    {{ "shared.confirm" | translate }}
  </button>
</div>
